<template>
  <div class="col-md-3 text-center rating">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <defs>
        <clipPath id="aaaa">
          <rect
            class="aaaa"
            width="48"
            height="48"
            transform="translate(-2827 -3727)"
          />
        </clipPath>
      </defs>
      <g class="bbbb" transform="translate(2827 3727)">
        <g transform="translate(-2825.755 -3727)">
          <path
            class="cccc"
            d="M41.918,3.208a.853.853,0,0,1-.632-.779l-.04-.768a.854.854,0,0,0-1.568-.415l-.418.643a.853.853,0,0,1-.939.359l-.74-.2A.854.854,0,0,0,36.7,3.415l.482.6a.846.846,0,0,1,.143.8l4.911-1.518Zm0,0"
          />
          <path
            class="dddd"
            d="M42.659,3.406l-.427-.115L37.323,4.8a.837.837,0,0,1-.085.2l-.418.643a.854.854,0,0,0,1.024,1.261l.715-.275a.853.853,0,0,1,.969.256l.483.6a.853.853,0,0,0,1.516-.581l-.04-.768a.853.853,0,0,1,.546-.841l.716-.275a.853.853,0,0,0-.09-1.616Zm0,0"
          />
          <path
            class="eeee"
            d="M14.253,4.292a.853.853,0,0,0-.884-1.365l-3.648.981a.827.827,0,0,1-.341.012l-4.862,9.1-.046.894a.853.853,0,0,0,1.516.582l2.376-2.935a.854.854,0,0,1,.969-.256l3.526,1.353A.853.853,0,0,0,13.883,11.4L11.82,8.229a.854.854,0,0,1,.052-1Zm0,0"
          />
          <path
            class="ffff"
            d="M8.783,3.55,6.727.383A.853.853,0,0,0,5.163.8l-.2,3.772a.853.853,0,0,1-.631.78L.682,6.33A.854.854,0,0,0,.6,7.951L4.122,9.3a.854.854,0,0,1,.546.842l-.151,2.878,4.858-9.1A.848.848,0,0,1,8.783,3.55Zm0,0"
          />
          <path
            class="dddd"
            d="M30.267,18.338l-6.3-9.7a1.707,1.707,0,0,0-3.136.841l-.605,11.551a1.707,1.707,0,0,1-1.262,1.559L7.791,25.582a1.707,1.707,0,0,0-.171,3.243l10.8,4.145a1.707,1.707,0,0,1,1.094,1.683l-.54,10.283L31.011,18.959A1.68,1.68,0,0,1,30.267,18.338Zm0,0"
          />
          <path
            class="gggg"
            d="M45.081,18.787a1.707,1.707,0,0,0-1.767-2.723L32.14,19.058a1.69,1.69,0,0,1-1.129-.1L18.972,44.936,18.9,46.2a1.707,1.707,0,0,0,3.031,1.164l7.278-8.988a1.708,1.708,0,0,1,1.938-.52L41.951,42A1.707,1.707,0,0,0,44,39.482l-6.3-9.7a1.708,1.708,0,0,1,.105-2Zm0,0"
          />
        </g>
      </g>
    </svg>
    <p class="amount-title">4.5</p>
    <p class="text-center2">Đánh giá</p>
  </div>
</template>
<script>
export default {
  props: {
    user: Object
  }
}
</script>

<style lang="scss">
.rating {
  .aaaa {
  fill: #fff;
  stroke: #707070;
  }
  .bbbb {
  clip-path: url(#aaaa);
  }
  .cccc {
  fill: #ffe165;
  }
  .dddd {
  fill: #ffd839;
  }
  .eeee {
  fill: #ff9811;
  }
  .ffff {
  fill: #ffaf46;
  }
  .gggg {
  fill: #ffcd00;
  }
}
</style>



// WEBPACK FOOTER //
// itemRating.vue?89f9f67e